import React from 'react';
import { MDBBtn, MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBCol, MDBContainer, MDBIcon, MDBRow, MDBTypography, MDBView } from 'mdbreact';
import { Language } from '../../redux/store/base/language';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faSnapchatGhost } from "@fortawesome/free-brands-svg-icons";

// Import asset
import "./Footer.scss";
import Logo from "./../../assets/images/icon/logoWithText.svg";
import GooglePlay from "./../../assets/images/icon/GooglePlay.svg";
import AppStore from "./../../assets/images/icon/AppSore.svg";

const Footer = (props: FooterProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <MDBRow className="footer">
        <MDBCol sm="12">
            <h3 className="text-center mb-5">{dictionary?.download_app}</h3>
        </MDBCol>
        <MDBCol sm="12" className="mt-3">
            <MDBContainer className="items">
                <img src={GooglePlay} alt="" />
                <img src={AppStore} alt="" />
            </MDBContainer>
        </MDBCol>

        <div className="footer-copyright text-center py-3">
            <MDBContainer fluid>
                <MDBRow>

                    <MDBCol sm="12" md="4">
                        <img src={Logo} height="55px" className="m-sm-auto m-md-0 d-block" />
                    </MDBCol>

                    <MDBCol sm="12" md="4">
                        <p className="text-center m-0">
                            <FontAwesomeIcon icon={faSnapchatGhost} />
                            <FontAwesomeIcon icon={faTwitter} />
                            <FontAwesomeIcon icon={faFacebookF} />
                            {/* <i className="fab fa-twitter"></i>
                    <i className="fab fa-snapchat-ghost"></i> */}
                        </p>
                    </MDBCol>

                    <MDBCol sm="12" md="4">
                        <p className="text-center m-0">
                            {dictionary?.copyright}: &copy; {new Date("2020/06/02").getFullYear()}
                        </p>
                        <p className="text-center m-0">
                            <a href="https://www.fullscreen.sa"> {dictionary?.designer_by} </a>
                        </p>
                    </MDBCol>

                </MDBRow>
            </MDBContainer>
        </div>
    </MDBRow>
};

interface FooterProps { }
export default Footer;